import {
  CommandLineIcon,
  CpuChipIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';

import aboutTechnologyGraphic from './assets/about-abstract-tech.png';

const facts = [
  { icon: SparklesIcon, text: 'AI-assisted development for architecture planning, code exploration, refactoring, documentation, and delivery.' },
  { icon: CommandLineIcon, text: 'Prompt-driven workflows for QA automation, test planning, debugging, and engineering process improvements.' },
  { icon: CpuChipIcon, text: 'Enterprise React, Next.js, and TypeScript products across e-commerce, SaaS, healthcare, telecom, gaming, and media.' },
];

const About = () => (
  <section className="about-section" id="about">
    <div className="section-shell about-grid">
      <div className="about-copy reveal reveal-left" data-reveal>
        <p className="eyebrow">The person behind the pixels</p>
        <h2>
          Built with
          <span className="heading-lime"> AI fluency.</span>
          <br />
          Refined through
          <span className="heading-lime"> experience.</span>
        </h2>
        <p className="about-copy-desktop">
          I&apos;m Jorge Castillo, a Senior Front-End Software Engineer who enjoys
          turning complex requirements into clear, scalable customer-facing
          products. I specialize in React, Next.js, TypeScript, AI-assisted
          development, responsive design, application performance, and accessible
          user experiences.
        </p>
        <p className="about-copy-desktop">
          AI is part of how I work day to day, and my 16 years of engineering
          experience give that work a valuable foundation. I use AI to analyze
          unfamiliar codebases, plan architecture, generate and review
          implementation paths, improve tests, automate QA workflows, document
          decisions, and speed up delivery without losing engineering judgment.
        </p>
        <p className="about-copy-desktop">
          I&apos;ve introduced AI-powered engineering workflows, supported QA process
          improvements, modernized legacy enterprise applications, and partnered
          with Product, UX, Backend Engineering, and QA to ship useful software
          across e-commerce, SaaS, healthcare, telecommunications, gaming, and media.
        </p>
        <p className="about-copy-mobile">
          I&apos;m Jorge Castillo, a Senior Front-End Software Engineer with 16
          years of experience modernizing enterprise web applications. That
          foundation makes my AI-assisted workflows stronger across architecture,
          coding, QA automation, testing, documentation, and delivery.
        </p>
      </div>

      <div className="about-visual reveal reveal-right" data-reveal>
        <img
          src={aboutTechnologyGraphic}
          alt="Abstract technology artwork representing software architecture and data flow"
        />
        <div className="about-stat">
          <strong>16+</strong>
          <span>years building for the web</span>
        </div>
      </div>
    </div>

    <div className="section-shell fact-grid">
      {facts.map(({ icon: Icon, text }) => (
        <div
          className="fact-item reveal reveal-up"
          data-reveal
          key={text}
        >
          <Icon aria-hidden="true" />
          <p>{text}</p>
        </div>
      ))}
    </div>
  </section>
);

export default About;
